<template>
  <div>
    <Hero
      title="Haft Poznań - P. Woźny"
      subTitle="Wszystkie nasze zlecenia wykonujemy terminowo. <br/>Jesteśmy skrupulatni i elastyczni. <br/> Gwarantujemy najwyższą jakość usług na rynku.<br/>"
      buttonText="Oferta"
      buttonLink="/oferta"
      buttonText2="Kontakt"
      buttonLink2="/kontakt"
    />

    <!-- start how  it works -->
    <section class="relative px-4 py-20 text-center sm:px-8 lg:px-16 xl:px-40 2xl:px-64">
      <div>
        <div class="mb-10 text-center">
          <h1
            class="mb-4 text-2xl font-medium text-gray-900 sm:text-3xl title-font"
          >Oferta Haft Poznań | P. Woźny</h1>
          <p>Dostarczamy profesjonalne rozwiązania dla firm, klubów sportowych oraz osób pragnących stworzyć własne linie odzieżowe oparte o haft.</p>
          <div class="flex justify-center mt-6">
            <div class="inline-flex w-16 h-1 bg-blue-600 rounded-full"></div>
          </div>
        </div>
      </div>

      <div>
        <div class="mb-5 text-center">
          <h2 class="py-5 my-4 text-xl font-bold text-blue-60">W naszeje ofercuie znajdziecie:</h2>
        </div>
      </div>

      <div class="flex flex-col items-start justify-between mt-12 md:flex-row">
        <div class="w-full px-4 py-6 bg-white rounded-lg shadow-lg lg:p-8 md:mx-2 lg:mx-4">
          <img src="../assets/icon-home-1.svg" alt class="h-32 mx-auto" />
          <h4 class="mt-8 text-xl font-bold leading-tight">Haft</h4>
          <p class="mt-2 text-gray-700">Więcej</p>
        </div>

        <div
          class="w-full px-4 py-6 mt-4 bg-white rounded-lg shadow-lg lg:p-8 md:mx-2 lg:mx-4 md:mt-0"
        >
          <img src="../assets/icon-home-2.svg" alt class="h-32 mx-auto" />
          <h4 class="mt-8 text-xl font-bold leading-tight">Laser</h4>
          <p class="mt-2 text-gray-700">Więcej</p>
        </div>

        <div
          class="w-full px-4 py-6 mt-4 bg-white rounded-lg shadow-lg lg:p-8 md:mx-2 lg:mx-4 md:mt-0"
        >
          <img src="../assets/icon-home-3.svg" alt class="h-32 mx-auto" />
          <h4 class="mt-8 text-xl font-bold leading-tight">Usługi projektowe</h4>
          <p class="mt-2 text-gray-700">Więcej</p>
        </div>
      </div>

      <div class="w-full mx-auto mt-12 md:mt-20 md:max-w-3xl">
        <router-link
          to="/o-firmie"
          class="py-5 my-4 text-xl font-bold text-blue-600"
        >Dowiedz się więcej</router-link>
        <p class="text-sm tracking-wider text-gray-700 uppercase"></p>
      </div>
    </section>
    <Testimonials />
    <Clients />
    <!-- end how it works -->
  </div>
</template>

<script>
import Hero from "../components/Hero";
import Clients from "../components/Clients";
import Testimonials from "../components/Testimonials";

export default {
  name: "Home",
  components: {
    Hero,
    Clients,
    Testimonials,
  },
  data() {
    return {
      expanded: false,
      value: 1,
    };
  },
  methods: {
    toggleCardState() {
      this.expanded = !this.expanded;
    },
    closeAll() {
      this.expanded = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
